module.exports = __webpack_public_path__ + "static/works_01-b8b9b82745780d65cb6fa361f3f739ff.jpg";